import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  errorMessage: 'Please enter a valid hex code.',
  titleDesktop: 'Select Accent Colour',
  titleMobile: 'Select Colour',
})
